import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var MarkupIcon24Regular = forwardRefAndName('MarkupIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M10.6451 10.3394C10.9547 10.6146 10.9826 11.0887 10.7074 11.3983L8.80347 13.5402L10.7074 15.682C10.9826 15.9916 10.9547 16.4657 10.6451 16.7409C10.3355 17.0161 9.86144 16.9882 9.58625 16.6786L7.53472 14.3706C7.11373 13.897 7.11373 13.1833 7.53472 12.7097L9.58625 10.4017C9.86144 10.0921 10.3355 10.0643 10.6451 10.3394Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M13.2926 11.3983C13.0174 11.0887 13.0453 10.6146 13.3549 10.3394C13.6645 10.0643 14.1385 10.0921 14.4137 10.4017L16.4652 12.7097C16.8862 13.1833 16.8862 13.897 16.4652 14.3706L14.4137 16.6786C14.1385 16.9882 13.6645 17.0161 13.3549 16.7409C13.0453 16.4657 13.0174 15.9916 13.2926 15.682L15.1965 13.5402L13.2926 11.3983Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.25 6C4.25 3.92893 5.92893 2.25 8 2.25H13.2564C13.9858 2.25 14.6853 2.53973 15.201 3.05546L18.9445 6.79902C19.4603 7.31475 19.75 8.01422 19.75 8.74357V18C19.75 20.0711 18.0711 21.75 16 21.75H8C5.92893 21.75 4.25 20.0711 4.25 18V6ZM8 3.75C6.75736 3.75 5.75 4.75736 5.75 6V18C5.75 19.2426 6.75736 20.25 8 20.25H16C17.2426 20.25 18.25 19.2426 18.25 18V8.74357C18.25 8.41205 18.1183 8.0941 17.8839 7.85968L14.1403 4.11612C13.9059 3.8817 13.588 3.75 13.2564 3.75H8Z"
    }))
  );
});